import { fetchAuthSession } from 'aws-amplify/auth';

// // Configure the URL for the api query.
const endpointUrl = 'https://ugczaq3r89.execute-api.us-east-1.amazonaws.com/dev/getisolvedemployees';

export const getISolvedEmployees = async (props) => {
    const { createdById } = props;

    const params = { createdById };
    const session = await fetchAuthSession();
    const authToken = `Bearer ${session.tokens.idToken}`;

    const inputJSON = JSON.stringify(params);

    try {
        const response = await fetch(endpointUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authToken,
            },
            body: inputJSON,
        });

        if (!response.ok) {
            throw new Error('Network response was not ok: ' + response.statusText);
        }

        const data = await response.json(); // Quick response from Lambda
        console.log('Lambda response:', data);
        return data; // Returns confirmation message
        // return true;
    } catch (error) {
        console.error('Error triggering Lambda:', error);
        throw error;
    }
};
